import React from "react"
import PropTypes from "prop-types"
import { Wrap, WrapItem, SlideFade, Heading } from "@chakra-ui/react"
import SEO from "../components/seo"
import Layout from "../components/layout"
import BikeCard from "../components/bikeCard"
import FilterProvider, { FilterContext } from "../components/filterContext"
import FilterComponent from "../components/filterComponent"
import Empty from "../img/empty.svg"
import { FormattedMessage } from "gatsby-plugin-intl"

const Bikes = ({ location }) => {
  return (
    <>
      <FilterProvider>
        <SEO title="Sykler" />
        <Layout location={location} container>
          <div className="sc-index-wrapper">
            <FilterComponent />
            <Wrap flex="1">
              <FilterContext.Consumer>
                {context => {
                  const { allBikes, filteredBikes, filters } = context
                  const renderBikes =
                    Object.keys(filters).length > 0 ? filteredBikes : allBikes
                  return (
                    <>
                      {renderBikes.length === 0 && (
                        <div className="sc-empty-wrapper">
                          <SlideFade in>
                            <div className="sc-empty">
                              <img src={Empty} alt="" />
                              <Heading marginTop="10" size="lg">
                                <FormattedMessage id="foundNoBikes" />
                              </Heading>
                            </div>
                          </SlideFade>
                        </div>
                      )}
                      {renderBikes
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((bike, i) => (
                          <WrapItem
                            key={`${bike.name}${i}`}
                            marginLeft="8"
                            marginRight="8"
                            width={["100%", "100%", "40%", "26%"]}
                          >
                            <BikeCard bike={bike} />
                          </WrapItem>
                        ))}
                    </>
                  )
                }}
              </FilterContext.Consumer>
            </Wrap>
          </div>
        </Layout>
      </FilterProvider>
    </>
  )
}

Bikes.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
}

export default Bikes
